import { ElementRef, EventEmitter, Output, Directive, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
    selector: '[deferLoad]',
})
export class DeferLoadDirective {
    @Output() public deferLoad: EventEmitter<any> = new EventEmitter();

    private _intersectionObserver?: IntersectionObserver;

    constructor(
        private _element: ElementRef,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    public ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId) && typeof IntersectionObserver !== 'undefined') {
            this._intersectionObserver = new IntersectionObserver(entries => {
                this.checkForIntersection(entries);
            }, {});
            this._intersectionObserver.observe(<Element>(this._element.nativeElement));
        }
    }

    private checkForIntersection = (entries: Array<IntersectionObserverEntry>) => {
        entries.forEach((entry: IntersectionObserverEntry) => {
            if (this.checkIfIntersecting(entry)) {
                this.deferLoad.emit();
                this._intersectionObserver.unobserve(<Element>(this._element.nativeElement));
                this._intersectionObserver.disconnect();
            }
        });
    }

    private checkIfIntersecting(entry: IntersectionObserverEntry) {
        return (<any>entry).isIntersecting && entry.target === this._element.nativeElement;
    }
}